import React, { useEffect, useState } from 'react'
import SelectPersonModal from './SelectPersonModal'
import tenantApi from '../api/tenant/TenantApi'
import { PersonLiteDto } from '../api/person/models/PersonDto'
import personApi from '../api/person/PersonApi'
import Button from './Button'

type Props = {
    currentNetworkLinksIds: string[]
    onClose: (newIds: string[], confirmed: boolean) => void
    onLiveSelectChange: (person: PersonLiteDto, selected: boolean) => void
}

function AddNetworkLinksModal({
    currentNetworkLinksIds: currentNetworkLinksIds,
    onClose,
    onLiveSelectChange,
}: Props): React.JSX.Element {
    const [availableNetworkLinksPersons, setAvailableNetworkLinksPersons] =
        useState<PersonLiteDto[]>([])
    const [isModalLoading, setIsModalLoading] = useState<boolean>(false)
    // const [enableButtons, setEnableButtons] = useState<boolean>(false)
    const [selectedPersonIds, setSelectedPersonIds] = useState<string[]>([])

    useEffect(() => {
        async function fetchAvailableNetworkLinks() {
            setIsModalLoading(true)
            // TODO: in future this needs to be paginated
            const availableNetworkLinksIds = (
                await tenantApi.getAvailableSeeds()
            ).availableSeedIds

            // remove the current hiring managers from the available list
            const unselectedAvailableNetworkLinksIds =
                availableNetworkLinksIds.filter(
                    (id) => !currentNetworkLinksIds.includes(id),
                )

            // now get the PersonLite from the server, using the cache if the persons are in there
            const availableNetworkLinksPersons = (
                await personApi.getPersonsLite({
                    personIds: unselectedAvailableNetworkLinksIds,
                })
            ).persons

            setAvailableNetworkLinksPersons(availableNetworkLinksPersons)
            setIsModalLoading(false)
        }
        fetchAvailableNetworkLinks()
    }, [currentNetworkLinksIds])

    async function handleSelectPersonChanged(
        person: PersonLiteDto,
        selected: boolean,
    ) {
        const personId = person.id
        let newSelectedPersonIds: string[]

        if (selected) {
            newSelectedPersonIds = [...selectedPersonIds, personId]
            setSelectedPersonIds(newSelectedPersonIds)
        } else {
            newSelectedPersonIds = selectedPersonIds.filter(
                (id) => id !== personId,
            )
            setSelectedPersonIds(newSelectedPersonIds)
        }

        // if (newSelectedPersonIds.length > 0) {
        //     setEnableButtons(true)
        // } else {
        //     setEnableButtons(false)
        // }
    }

    async function addToNetworkLinks(addAll = false) {
        if (addAll) {
            onClose(
                availableNetworkLinksPersons.map((person) => person.id),
                true,
            )
        } else {
            onClose(selectedPersonIds, true)
        }
        return
    }

    function handleOnClose() {
        onClose(selectedPersonIds, true)
    }

    return (
        <SelectPersonModal
            persons={availableNetworkLinksPersons}
            title="Add Network Links"
            onClose={handleOnClose}
            onSelectChanged={(person, selected) => {
                handleSelectPersonChanged(person, selected)
                onLiveSelectChange(person, selected)
            }}
            multiSelectButtons={
                <div className="flex gap-2">
                    <Button
                        style="secondary"
                        type="button"
                        onClick={() => addToNetworkLinks(true)}
                        enabled={availableNetworkLinksPersons.some(
                            (p) => !selectedPersonIds.includes(p.id),
                        )}
                    >
                        Add All{' '}
                        {
                            availableNetworkLinksPersons.filter(
                                (p) => !selectedPersonIds.includes(p.id),
                            ).length
                        }{' '}
                        to Network Links
                    </Button>
                </div>
            }
            isLoading={isModalLoading}
        />
    )
}

export default AddNetworkLinksModal
